export const getModelToUse = ({ taskName, taskInputType, taskInputTokens }) => {
	if (taskInputType === "description" || taskInputTokens > 16000) {
		return "llm-large"
	} else {
		return "llm-fast"
	}
}
